"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchableInputProperties = exports["default"] = void 0;

var _baseColors = _interopRequireDefault(require("../baseColors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var searchableInput = {
  addAsTextColor: _baseColors["default"].atomic
};
var searchableInputProperties = {
  addAsTextHeight: '32px',
  underline: 'underline'
};
exports.searchableInputProperties = searchableInputProperties;
var _default = searchableInput;
exports["default"] = _default;